import axios from "../../utils/axiosConfig";

import { DailyExpenseDTO, DeleteDailyExpenseDTO, UpdateDailyExpenseDTO } from "../../dtos/expensesDTO";

export const add_daily_expense = async (expense: DailyExpenseDTO) => { 
    const { data } = await axios.post('/api/daily_pharmacy_expense/add', expense);
    return data;
  };

export const get_daily_expense = async (pharmacy_id: number, start_date:string,end_date:string, limit:number , page:number) => {
    const url = `/api/daily_pharmacy_expense/get?pharmacy_id=${encodeURIComponent(pharmacy_id)}&start_date=${start_date}&end_date=${end_date}&limit=${limit}&page=${page}`;
    const { data } = await axios.get(url);
    return data;
}

export const delete_daily_expense = async (dto: DeleteDailyExpenseDTO) => {
    const {data} = await axios.delete(
        `/api/daily_pharmacy_expense/delete?pharmacy_id=${dto.pharmacy_id}&exp_id=${dto.exp_id}`
    );
    return data;
}

export const update_daily_expense = async (expense_update: UpdateDailyExpenseDTO) => {
    const url = '/api/daily_pharmacy_expense/update';
    const { data } = await axios.put(url, expense_update);
    return data;
  };